import { render, staticRenderFns } from "./Stanowiska.vue?vue&type=template&id=5b5d7470&scoped=true&"
import script from "./Stanowiska.vue?vue&type=script&lang=js&"
export * from "./Stanowiska.vue?vue&type=script&lang=js&"
import style0 from "./Stanowiska.vue?vue&type=style&index=0&id=5b5d7470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d7470",
  null
  
)

export default component.exports